import { colors } from '@piconetworks/pkg-functions';
import { ThemePageContrastColor, FormPageContrastColor } from './PageContrastColor.js';
import PropertyType from '../Modifiers/PropertyType.js';

var makePageButtonContrastColor = function makePageButtonContrastColor(property) {
  var value = property.getCssVariableValue();
  var hasBeenModified = property.getHasBeenModified();
  if (value !== undefined && hasBeenModified) {
    return colors.getContrastColor(value);
  } else {
    return;
  }
};
var makeCssPageButtonContrastColor = function makeCssPageButtonContrastColor(property) {
  var color = makePageButtonContrastColor(property);
  if (color !== undefined) {
    return "background-color: " + color + ";";
  } else {
    return;
  }
};
var ThemePageButtonContrastColor = new PropertyType({
  name: 'PageButtonContrastColor',
  propertyFromApi: 'page-button-contrast-color',
  convertValueToCssPropertiesFunction: function convertValueToCssPropertiesFunction(value) {
    return makeCssPageButtonContrastColor(ThemePageContrastColor);
  },
  isCompounded: true,
  selector: '.page > .btn',
  priority: 7,
  cssVariable: '--page-button-contrast-color',
  cssVariableFunction: function cssVariableFunction(value) {
    return makePageButtonContrastColor(ThemePageContrastColor);
  },
  convertToRgb: true
}, 'theme');
var FormPageButtonContrastColor = new PropertyType({
  name: 'PageButtonContrastColor',
  propertyFromApi: 'page-button-contrast-color',
  convertValueToCssPropertiesFunction: function convertValueToCssPropertiesFunction(value) {
    return makeCssPageButtonContrastColor(FormPageContrastColor);
  },
  isCompounded: true,
  selector: '.page > .btn',
  priority: 8,
  cssVariable: '--page-button-contrast-color',
  cssVariableFunction: function cssVariableFunction(value) {
    return makePageButtonContrastColor(FormPageContrastColor);
  },
  convertToRgb: true
}, 'form');

export { FormPageButtonContrastColor, ThemePageButtonContrastColor };
//# sourceMappingURL=PageButtonContrastColor.js.map
